module.exports = __webpack_public_path__ + "img/upload-02.2fec290a.svg";